"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const ulid_1 = require("ulid");
const EventBackendFactory_1 = require("./backend/EventBackendFactory");
const EventsBackendNull_1 = require("./backend/EventsBackendNull");
class EventsClient extends base_client_1.ApiBasicAuthClient {
    constructor(apiConfig = {
        baseURL: `${process.env.EVENT_SERVICE_URL}`,
        basicAuthUser: process.env.EVENT_BASIC_AUTH_USER,
        basicAuthPassword: process.env.EVENT_BASIC_AUTH_PASSWORD,
    }) {
        super(apiConfig);
        this.apiConfig = apiConfig;
        this.eventBackends = [new EventsBackendNull_1.EventsBackendNull()];
        try {
            const eventsConfigStr = process.env.EVENTS_CONFIG;
            if (!eventsConfigStr) {
                commons_logs_1.log.error("Undefined EVENTS_CONFIG environment variable, will ignore events");
            }
            else {
                const configs = JSON.parse(eventsConfigStr);
                for (const config of configs) {
                    this.eventBackends.push(EventBackendFactory_1.EventBackendFactory.getBackend(config));
                }
            }
        }
        catch (err) {
            commons_logs_1.log.error("Bad EVENTS_CONFIG, will ignore events", err);
            this.eventBackends = [new EventsBackendNull_1.EventsBackendNull()];
        }
    }
    async submit(sellerId, eventType, eventPayload, eventSource, groupId, context, dimensions) {
        const event = {
            id: (0, ulid_1.ulid)(),
            createdAt: new Date().toISOString(),
            sellerId,
            type: eventType,
            payload: eventPayload,
            eventSource,
            groupId,
            context: context !== null && context !== void 0 ? context : {},
            dimensions: dimensions !== null && dimensions !== void 0 ? dimensions : {},
        };
        await Promise.all(this.eventBackends.map(async (backend) => backend.submit(event)));
        return event.id;
    }
    async submitEvent(event) {
        await Promise.all(this.eventBackends.map(async (backend) => backend.submit(Object.assign(Object.assign({}, event), { id: (0, ulid_1.ulid)(), createdAt: new Date().toISOString() }))));
    }
    async queryEvents(logisticsAccountId, query) {
        if (!this.apiConfig.baseURL || !this.apiConfig.basicAuthUser || !this.apiConfig.basicAuthPassword) {
            commons_logs_1.log.error("To query events, environment variables must be set: EVENT_SERVICE_URL, EVENT_BASIC_AUTH_USER, EVENT_BASIC_AUTH_PASSWORD");
            return Promise.resolve([]);
        }
        const queryPayload = Object.fromEntries(Object.entries(query).map((x) => (x[0] === "after" ? ["after", x[1].toISOString()] : x)));
        return this.get("/logistics/api/unstable/events", queryPayload, {
            "x-shopify-logistics-account-id": logisticsAccountId,
        });
    }
    async querySellerEvents(sellerId, query) {
        if (!this.apiConfig.baseURL || !this.apiConfig.basicAuthUser || !this.apiConfig.basicAuthPassword) {
            commons_logs_1.log.error("To query events, environment variables must be set: EVENT_SERVICE_URL, EVENT_BASIC_AUTH_USER, EVENT_BASIC_AUTH_PASSWORD");
            return Promise.resolve([]);
        }
        const queryPayload = Object.fromEntries(Object.entries(query).map((x) => (x[0] === "after" ? ["after", x[1].toISOString()] : x)));
        return this.get(`/logistics/api/unstable/events/bySellerId/${sellerId}`, queryPayload);
    }
}
exports.EventsClient = EventsClient;
//# sourceMappingURL=EventsClient.js.map